import axios from 'axios';

export const deleteSwrFetcher = async <T, R>(url: string, { arg }: { arg: T }) => {
  const response = await axios.delete<R>(url, { data: arg });

  return response.data;
};
